import { type Transaction, TransactionSide } from "@/apis/gql/types";
import {
  TypographyCaption,
  TypographyMuted,
  TypographySmall,
} from "@/components/ui/typography";
import { cn, formatAmount } from "@/lib/utils";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { SignedAmount } from "@/components/shared/miscellaneous/signed-amount";

type PanelHeaderProps = {
  transactions: Transaction[];
};

export const TransactionsPanelHeader = ({ transactions }: PanelHeaderProps) => {
  const { t } = useTranslation();

  const hasMultipleSelectedTransactions = transactions.length > 1;

  return (
    <div className="py-1.5 px-2 rounded-md border border-gray-200">
      {hasMultipleSelectedTransactions ? (
        <div className="flex flex-row">
          <div className="flex flex-row flex-1 flex-wrap items-center">
            <TypographySmall>
              {t("transactions.search_panel.header.multiple_selected", {
                count: transactions.length,
              })}
            </TypographySmall>
          </div>
        </div>
      ) : (
        <div className="flex flex-row">
          <div className="flex flex-1 flex-col">
            <TypographyCaption className="text-xs text-muted-foreground">
              {format(transactions[0].bookingDate, "dd.MM.yyyy")}
            </TypographyCaption>
            <TypographySmall className="text-sm">
              {transactions[0].counterpartyName}
            </TypographySmall>
            <TypographyMuted className="text-sm text-muted-foreground">
              {transactions[0].purpose}
            </TypographyMuted>
          </div>
          <div className="flex items-center justify-center">
            <SignedAmount
              amount={transactions[0].amount}
              currency={transactions[0].currency}
              side={transactions[0].side}
              originalAmount={transactions[0].originalAmount}
              originalCurrency={transactions[0].originalCurrency}
            />
          </div>
        </div>
      )}
    </div>
  );
};
